import { LENDERS } from './lenders';
import { STATES } from './states';

export const DEFAULT_ACTIVE = {
  optionKey: 1,
  lender: LENDERS[0],
  state: STATES[0],
};
